<template>
  <ion-page>
    <master-layout @refreshPage="reRender" pageTitle="ویرایش اطلاعات مشتری">

          <Loading :is="!customerLoaded" v-if="!customerLoaded"></Loading>
          <div v-if="customerLoaded">
            <div v-if="customer">
              <ion-card-content class="mb-1">
                <div class="mb-1">
                  <span>کد اشتراک: </span><span>{{customer.subscription_code}}</span>
                </div>
                <div>
                  <span v-if="customer.plans">پلن :
                  <i class="plans" v-for="(c,index) in customer.plans" :key="index" :style="'background:'+ c.color+';'">{{c.title}}</i>
                  </span>
                  <span v-else>پلن : --</span>
                </div>

              <div class="d-flex-between mb-1 mt-1">
                <div>
                  <span>عنوان: </span><span>{{customer.title?customer.title:''}}</span>
                </div>
                <div>
                  <span>نام کامل: </span><span>{{customer.fullname}}</span>
                </div>
              </div>
                <div class="d-flex-between">
                  <div>
                    <span>وضعیت : {{customer.status?customer.status:'--'}}</span>
                  </div>
                  <div>
                    <i class="far fa-phone"></i>&nbsp;
                    0{{customer.phone}}
                  </div>
                </div>
              <br>
              <AjaxForm route="customer/Edit" :callback="customerEditResponse">
                <input class="" type="hidden" name="id" :value="customer._id">

                <div v-if="currentUser.allow_edit_user" class="mb-2">
                  <label>نام کامل</label>
                  <input class="form-control" name="fullname" v-model="customer.fullname" placeholder="نام کامل ...">
                </div>

                <div v-if="currentUser.allow_edit_user" class="mb-2">
                  <label>عنوان</label>
                  <input class="form-control" name="title" v-model="customer.title" placeholder="عنوان ...">
                </div>


                <div class="mb-2">
                  <label>آدرس</label>
                  <textarea name="address_text" class="form-control" v-model="customer.address_text"></textarea>
                  </div>

                <div class="mb-2">
                  <label>تلفن ثابت</label>
                  <input type="tel" name="telephone" class="form-control" :value="customer.telephone?customer.telephone:''">
                </div>
                <div class="mb-2">
                  <label>تلفن همراه</label>
                  <input type="tel" name="phone" class="form-control" :value="customer.phone?customer.phone:''">
                </div>



                <button class="btn btn-block btn-lg btn-success mt-1 mb-1" type="submit">
                  به روز رسانی اطلاعات <i class="fas fa-edit"></i>
                </button>
              </AjaxForm>
                <router-link :to="'/Order/Add/' + customer._id " class="btn btn-info btn-block mb-1">ثبت سفارش</router-link>
                <router-link :to="'/incoming/Add/' + customer._id " class="btn btn-primary btn-block mb-1">ثبت سند دریافتی</router-link>
                <div class="d-flex-between">
                  <a :href="'geo:'+customer.lat+','+customer.lng" data-toggle="tooltip" data-placement="top" title="مسیریابی" class="btn btn-primary"><i class="far fa-directions"></i></a>
                  <a :href="'tel:' + customer.phone" data-toggle="tooltip" data-placement="top" title="تماس" class="btn btn-primary"><i class="far fa-phone"></i></a>
                  <a :href="'sms:' + customer.phone" data-toggle="tooltip" data-placement="top" title="ارسال پیامک" class="btn btn-primary"><i class="far fa-envelope"></i></a>
                </div>
              </ion-card-content>

              <div id="main">
                <nav :class="active" v-on:click.prevent>

                  <a href="#" class="home" @click="makeActive('home')">نقشه</a>
                  <a href="#" class="projects" @click="makeActive('projects')">اطلاعات جزئی</a>
                  <a href="#" class="services" @click="makeActive('services')">گردش حساب</a>
                  <a href="#" class="contact" @click="makeActive('contact')">گزارشات</a>
                </nav>

                <div :style="active==='home'?'display:block;':'display:none;'" >
                  <AjaxForm :route="'customer/EditLocation/'+customer._id">
                    <div class="p-1">
                      <button class="btn btn-info btn-block" style="margin-top: 0;" type="submit">ویرایش موقعیت مشتری</button>
                    </div>
                  <div id="map_div" ref="map_div">
                    <div id="map2"></div>
                  </div>
                    <input type="hidden" name="lat" v-model="lat" readonly>
                    <input type="hidden" name="lng" v-model="lng" readonly>
                  </AjaxForm>
                </div>
                <div :style="active==='projects'?'display:block;':'display:none;'">
                  <ion-card-content>
                    <AjaxForm route="customer/EditMinorInfo">
                      <input class="" type="hidden" name="id" :value="customer._id">
                    <div class="mb-2">
                      <label>کد ملی</label>
                      <input type="tel" name="national_code" class="form-control" :value="customer.national_code">
                    </div>

                    <div class="mb-2">
                      <label>شماره پروانه</label>
                      <input name="license_number" type="tel" class="form-control" :value="customer.license_number">
                    </div>

                    <div class="mb-2">
                      <label>تاریخ پروانه</label>
                      <date-input  name="license_date" v-model="customer.license_date"></date-input>
                    </div>

                    <ExtraField v-for="item in extraFields" :key="item" :item="item" :object="customer"></ExtraField>

                    <div class="mb-2" v-if="customer.description">
                      <label>توضیحات</label>
                      <div class="border">
                        {{customer.description}}
                      </div>
                    </div>
                      <button class="btn btn-success btn-block" type="submit">ویرایش اطلاعات <i class="far fa-edit"></i></button>
                    </AjaxForm>
                  </ion-card-content>
                </div>
                <div :style="active==='services'?'display:block;':'display:none;'">
                  <IonCardContent>
                    <div>مانده حساب :
                    <span v-if="customer.balance > 0" class="text-success"><Money :number="customer.balance"></Money> طلبکار</span>
                    <span v-if="customer.balance < 0" class="text-danger"><Money :number="Math.abs(customer.balance)"></Money> بدهکار</span>
                    </div>
                  <DataTable order-by="0" order-type="desc" v-if="tr_route" card="1" :route="tr_route" :headers="tr_headers"></DataTable>
                  </IonCardContent>
                </div>
                <div :style="active==='contact'?'display:block;':'display:none;'">
                  <IonCardContent>گزارشات</IonCardContent>
                </div>
              </div>

            </div>
            <div v-if="error" class="alert alert-danger">
              {{ error }}
            </div>
          </div>
    </master-layout>
  </ion-page>
</template>

<script>
import L from "leaflet";

require('leaflet.locatecontrol')
import {mapActions, mapGetters} from "vuex";
import {IonPage, IonCardContent, IonCardHeader} from '@ionic/vue';
import AjaxForm from "@/components/AjaxForm";
import ExtraField from "@/components/ExtraField";
import DataTable from "../../components/DataTable";
import Money from "../../components/Money";
import {showSystemNoti} from "../../shared/helper";
import DateInput from "@/components/DateInput.vue";

// import {getFormData} from '@/shared/helper'

export default {
  name: "EditCustomer",
  components: {
    DateInput,
    AjaxForm,DataTable,Money,
    IonPage, IonCardContent, IonCardHeader,ExtraField
  },
  data()
  {
    return {
      tr_route : null,
      tr_headers : ['تاریخ','شماره سند','وضعیت','نوع سند','بدهکار','بستانکار','مانده','مشاهده'],
      active: 'home',
      extraFields : [],
      id: null,
      customerLoaded: false,
      customer: null,
      error: null,
      states: [],
      map: null,
      lat : null,
      lng : null,
      cities: [{_id: 0, title: 'ابتدا استان را انتخاب نمایید'}]
    }
  },
  computed:{
    ...mapGetters("auth", {
      currentUser: "getUserInfo",
    })},
 mounted()
 {
   this.init();
 },
  methods: {
    async init()
    {
      this.active = 'home';
      this.extraFields = [];
      this.id = null;
      this.customerLoaded = false;
      this.customer = null;
      this.error = null;
      this.states = [];
      this.map = null;
      this.tr_route = null;
      this.id = this.$route.params.id;
      const result = await this.getCustomer(this.id);
      if (result)
      {
        if (result.ok)
        {
          const check = await this.getCustomerExtraFields();
          if (check && check.ok)
          {
            this.extraFields = check.fields;
          }
          this.customerLoaded = true;
          this.customer = result.customer;
          this.lat = this.customer.lat;
          this.lng = this.customer.lng;
          this.tr_route = 'customer/BalanceTransaction/ListAjax/'+this.customer._id;
          const self = this;
          setTimeout(function (){
            self.initMap();
          },1000)

        }
        else
        {
          this.customerLoaded = true;
          this.error = result.error
        }
      }
      else
      {
        this.customerLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }

    },
    makeActive: function(item){
      // When a model is changed, the view will be automatically updated.
      this.active = item;
    },
    customerEditResponse(data)
    {
      const self = this;
      if (data.ok)
      {
        showSystemNoti('success',data.message,function (){
          self.init();
        });
      }
      else
          showSystemNoti('danger',data.error);
    },
    ...mapActions("customer", {
      getCustomerExtraFields : 'getCustomerExtraFields',
      getCustomer: 'getCustomer'
    }),
    initMap()
    {
      this.map_html = this.$refs['map_div'];
      this.map_html.innerHTML = '<div id="map2" style="height: 300px"></div>';
      // $('#map_div').html('<div id="map2" style="height: 400px;direction: ltr;"></div>');
      var lat = this.customer.lat , lng= this.customer.lng;
      var zoom=15;
      var osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          osmAttrib = '&copy; <a href="https://carencar.com">کارن کار</a>',
          osm = L.tileLayer(osmUrl, {maxZoom: 18, attribution: osmAttrib});
      this.map = L.map('map2',{ zoomControl: true, dragging: true, boxZoom: true, scrollWheelZoom: true }).setView([lat,lng], zoom).addLayer(osm);
      L.control.locate({
        drawCircle: true, // controls whether a circle is drawn that shows the uncertainty about the location
        setView: true, // automatically sets the map view to the user's location, enabled if follow is true
        follow:true,
        flyTo:true,
        keepCurrentZoomLevel: false, // keep the current map zoom level when displaying the user's location. (if false, use maxZoom)
        circlePadding: [0, 0], // padding around accuracy circle, value is passed to setBounds
        locateOptions: {
          maxZoom: 15
        },
        strings: {
          title: "نمایش موقعیت فعلی", // title of the locate control
          popup: "موقعیت فعلی شما", // text to appear if user clicks on circle
          outsideMapBoundsMsg: "بنظر میاد شما در خارج از این کره خاکی هستید" // default message for onLocationOutsideMapBounds
        }
      }).addTo(this.map);
      // L.Control.geocoder().addTo(this.map);
      this.map.on('click',(e) =>{
        this.placeMarker(e);
      });
      this.placeMarker({
        latlng: {
          lat:lat,
          lng:lng
        }
    })

    },
    placeMarker(e)
    {
      try
      {
        if (this.markerHolder)
          this.markerHolder.removeFrom(this.map);
      } catch (e)
      {
        console.log(e);
      }

      const iconUrl = '/assets/img/order-marker.png';
      const markerIcon = new L.Icon({
        iconUrl: iconUrl,
        iconSize:  [30, 46],
        iconAnchor:   [17, 45],
      });
      this.markerHolder = new L.marker(e.latlng,{icon:markerIcon})
      this.markerHolder.addTo(this.map);
      this.lat = e.latlng.lat;
      this.lng = e.latlng.lng;
    },
    reRender()
    {
      this.init();
    }

  },watch : {
    "$route.path": {
      handler(newUrl,oldUrl)
      {
        if (newUrl.toLowerCase().indexOf('customer/edit') >= 0 && oldUrl.toLowerCase().indexOf('customer/edit') < 0)
        {
          this.init()
        }
      },
      deep:true
    },
  }
}

</script>

<style scoped>
#map2{
  height: 400px;
  direction: ltr;
}
.border
{
  border: 1px solid silver;
  padding: 8px;
  border-radius: 4px;
}
.d-flex-between
{
  display: flex;
  justify-content: space-between;
}
.ml-1
{
  margin-left: 5px;
}
.mb-1
{
  margin-bottom: 7px;
}
.mt-1
{
  margin-top: 7px;
}
.plans {
  margin-left: 6px;
  text-shadow: 0px 0px 2px black;
  padding: 0 5px;
  color: white;
  display: inline-block;
  margin-bottom: 4px;
}


/*-------------------------
	The menu
--------------------------*/

nav {
  display: flex;
  margin: 20px auto 0;
  background-color: #5597b4;
  box-shadow: 0 1px 1px #ccc;
  border-radius: 2px;
  width: 100%;
  justify-content: space-between;
}

nav a {
  width: 100%;
  display: inline-block;
  padding: 21px 3px;
  color: #fff !important;
  font-weight: bold;
  font-size: 12px;
  text-decoration: none !important;
  line-height: 1;
  text-transform: uppercase;
  background-color: transparent;
  transition: background-color 0.25s;
  text-align: center;
}

nav a:first-child {
  border-radius: 2px 0 0 2px;
}

nav a:last-child {
  border-radius: 0 2px 2px 0;
}

nav.home .home,
nav.projects .projects,
nav.services .services,
nav.contact .contact {
  background-color: #e35885;
}

p {
  font-size: 22px;
  font-weight: bold;
  color: #7d9098;
}

p b {
  color: #ffffff;
  display: inline-block;
  padding: 5px 10px;
  background-color: #c4d7e0;
  border-radius: 2px;
  text-transform: uppercase;
  font-size: 18px;
}

.p-1 {
  padding: 5px;
}


</style>